import type { HelpFile } from '../../types/help'
import { ThemeToggleTestIds } from '../../../testids/ThemeToggleTestIds'

// Symbolschalter in der Kopfleiste — das aria-label beschreibt die Aktion.
export const themeToggleHelp: HelpFile = {
  texts: {
    [ThemeToggleTestIds.btnThemeToggle]: null,
  },
}
